module.exports = __webpack_public_path__ + "media/images/subject_img/BIOLOGY-665ac91b3f674098baa7a937edbf284a.jpg";